var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGsViewSelectedWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visibility_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.067,
    height: 27.067,
    viewBox: "0 0 27.067 27.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16651",
    "data-name": "Path 16651",
    d: "M0,0H27.067V27.067H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16652",
    "data-name": "Path 16652",
    d: "M13.406,6.256a11.019,11.019,0,0,1,9.947,6.2,11.077,11.077,0,0,1-19.894,0,11.019,11.019,0,0,1,9.947-6.2m0-2.256A13.338,13.338,0,0,0,1,12.459a13.327,13.327,0,0,0,24.812,0A13.338,13.338,0,0,0,13.406,4Zm0,5.639a2.82,2.82,0,1,1-2.82,2.82,2.821,2.821,0,0,1,2.82-2.82m0-2.256a5.075,5.075,0,1,0,5.075,5.075A5.083,5.083,0,0,0,13.406,7.383Z",
    transform: "translate(0.128 0.511)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsViewSelectedWhiteIcon);
export default __webpack_public_path__ + "static/media/gs-viewSelected-whiteIcon.d3f87b710dd18829f52d69e6e8cc6992.svg";
export { ForwardRef as ReactComponent };